import React from "react";
import { Grid, TextField } from "@mui/material";

const FieldStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Contact" name="fieldContact" value={formData.fieldContact} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Permit Number" name="permitNumber" value={formData.permitNumber} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Address" name="fieldAddress" value={formData.fieldAddress} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Address 2" name="fieldAddress2" value={formData.fieldAddress2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field City" name="fieldCity" value={formData.fieldCity} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field State" name="fieldState" value={formData.fieldState} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Zip" name="fieldZip" value={formData.fieldZip} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Phone" name="fieldPhone" value={formData.fieldPhone} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Phone 2" name="fieldPhone2" value={formData.fieldPhone2} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Fax" name="fieldFax" value={formData.fieldFax} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Field Email" name="fieldEmail" value={formData.fieldEmail} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="County" name="county" value={formData.county} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField label="Field Notes" name="fieldNotes" value={formData.fieldNotes} onChange={handleChange} fullWidth size="small" multiline rows={2} />
      </Grid>
    </Grid>
  );
};

export default FieldStep;
